import { render, staticRenderFns } from "./ReportsDetails.vue?vue&type=template&id=492e1599"
import script from "./ReportsDetails.vue?vue&type=script&lang=js"
export * from "./ReportsDetails.vue?vue&type=script&lang=js"
import style0 from "./ReportsDetails.vue?vue&type=style&index=0&id=492e1599&prod&lang=css"
import style1 from "./ReportsDetails.vue?vue&type=style&index=1&id=492e1599&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports